<script>
	// From Lucide
	import { CircleHelp } from 'lucide-svelte';

	export let iconClass = '';
</script>

<CircleHelp class={iconClass} />
